// ----------------------------------------------------------------------------
// Snippet: Announcement Bar
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_announcement-bar.scss'


// -------------------------------------
// Variables
// -------------------------------------
const ANNOUNCEMENT_BAR = '.announcement-bar';
const ANNOUNCEMENT_BAR_CLOSE = '.announcement-bar__close';
const ANNOUNCEMENT_SESSION = sessionStorage.getItem('announcement-bar');


// -------------------------------------
// Hooks
// -------------------------------------
$(document).ready(function(){
	// Constant elements

	if (ANNOUNCEMENT_SESSION) {
	    $(ANNOUNCEMENT_BAR).addClass('announcement-bar--hidden');
	}

	$(ANNOUNCEMENT_BAR_CLOSE).on('click', function(event) {
	    event.preventDefault();

	    $(ANNOUNCEMENT_BAR).addClass('announcement-bar--hidden');

	    sessionStorage.setItem('announcement-bar', 'close');
	});
});

